import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './OpusAddressList.html?raw';
import Button from '../../../moreCore/UI/Button/Button';
import "../../../moreCore/UI/Button/Button";


class OpusAddressList extends compose(_WidgetBaseSP) {
    templateString: any = template;
    opusAddressList: HTMLTableElement;

    addressListAll: Array<Opus.OpusAddress> = [];

    refreshTable(listData: Array<Opus.OpusAddress>) {
        this.UiModder.domConstruct.empty(this.opusAddressList);
        let tr = this.opusAddressList.insertRow();
        this.UiModder.domConstruct.create("th", { "innerHTML": "<b>" + this.translations["OpusFinder_ColName_Address"] + "</b>" }, tr)
        this.UiModder.domConstruct.create("th", { "innerHTML": "<b>" + this.translations["OpusFinder_ColName_Prefix"] + "</b>" }, tr)
        this.UiModder.domConstruct.create("th", { "innerHTML": "<b>" + this.translations["OpusFinder_ColName_Function"] + "</b>" }, tr)
        this.UiModder.domConstruct.create("th", {}, tr)
        this.addTableRows(listData);
    }

    addTableRows(listData: Array<Opus.OpusAddress>) {

        let resortFlag = this.checkIfSortIsMessedUp(listData);
        
        if (listData.length > 0) {
            listData.forEach(lang.hitch(this, function (row: Opus.OpusAddress, index) {
                //let tr = self.UiModder.domConstruct.create("tr");
                if (resortFlag) {
                    row.order = index;
                    row.hasChanged = true;
                }
                this.addressListAll.push(row);

                let btnMoveUp = new Button();
                btnMoveUp._onClick_Button = lang.hitch(this, this.moveUp, row);
                btnMoveUp.setClasses("mds-gray mds-hover-dark");
                btnMoveUp.setLabel("");
                btnMoveUp.setIconLeft("fas fa-arrow-up");
                this.UiModder.domStyle.set(btnMoveUp.domNode, "float", "left");
                this.UiModder.domStyle.set(btnMoveUp.domNode, "margin-right", "8px");

                let btnMoveDown = new Button();
                btnMoveDown._onClick_Button = lang.hitch(this, this.moveDown, row);
                btnMoveDown.setClasses("mds-gray mds-hover-dark w3-margin-right");
                btnMoveDown.setLabel("");
                btnMoveDown.setIconLeft("fas fa-arrow-down");
                this.UiModder.domStyle.set(btnMoveDown.domNode, "float", "left");

                let btnRemove = new Button();
                btnRemove._onClick_Button = lang.hitch(this, this.remove, row);
                btnRemove.setLabel("");
                btnRemove.setIconLeft("fas fa-minus");
                btnRemove.setClasses("w3-red mds-hover-dark");
                this.UiModder.domStyle.set(btnRemove.domNode, "float", "left");

                let tr = this.opusAddressList.insertRow();
                this.UiModder.domConstruct.create('td', {
                    "innerHTML": row.ref_address.gDisp_Firstname_Name
                }, tr)
                this.UiModder.domConstruct.create('td', {
                    "innerHTML": row.prefix,
                }, tr)
                this.UiModder.domConstruct.create('td', {
                    "innerHTML": row.ref_relation_type.description
                }, tr)
                let td = this.UiModder.domConstruct.create('td')

                btnMoveUp.placeAt(td);
                btnMoveDown.placeAt(td);
                btnRemove.placeAt(td);
                this.UiModder.domConstruct.create(td, { "style": "float: right" }, tr);
            }))
        } else {
            let tr = this.opusAddressList.insertRow();
            this.UiModder.domConstruct.create('td', {
                "innerHTML": 'Keine Daten vorhanden!',
                "className": "w3-dark-grey",
                "colspan": "4"
            }, tr)
        }
    }

    checkIfSortIsMessedUp(list) {
        let tempList = list.map(data => data.order);
        let temp = tempList.filter((item, index) => tempList.indexOf(item) != index).length > 1;
        console.log("checkIfSortIsMessedUp?", temp)
        return temp;
    }

    moveDown(entity: any) {
        this.emit("dirty");
        this.addressListAll.filter(function (data) {
            if (data.order === entity.order + 1) {
                data.order = data.order - 1;
            }
        });

        entity.order++;

        this._resortAddressList();
    }

    moveUp(entity: any) {
        this.emit("dirty");
        this.addressListAll.filter(function (data) {
            if (data.order === entity.order - 1) {
                data.order = data.order + 1;
            }
        });

        entity.order--;

        this._resortAddressList();
    }

    _resortAddressList() {
        let tempList = this.addressListAll.sort(function (a, b) {
            return a.order - b.order;
        });
        this.addressListAll = [];

        this.refreshTable(tempList);
    }

    remove(entity: any) {
        if (entity.ID != undefined) {
            var url = window.appRoot + "OpusManagement/DeleteOpusAddress";

            this.StandbyStart();

            this.RequestManager.post(
                url,
                {
                    opusAddressId: entity.ID
                },
                lang.hitch(this, this._onDeleteOpusAddressResponse, entity),
                lang.hitch(this, this._onDeleteOpusAddressError),
                false // sync
            );
        } else {
            this.addressListAll = this.addressListAll.filter(data => data.order != entity.order);
            this._resortAddressList();
        }
        
    }

    _onDeleteOpusAddressResponse(entity, response: Opus.OpusResponse) {
        this.emit("deleted", entity);
        this.StandbyStop();
    }

    _onDeleteOpusAddressError(err: more.requestErrorMessage) {
        alert("ERROR beim DeleteOpusAddress: " + err.Message);
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(OpusAddressList);